import React from 'react'

import SmartMenu from '../../components/layout/navigation/components/SmartMenu.jsx'

import MinifyMenu from '../../components/layout/actions/MinifyMenu.jsx'

let rawItems = require('!json!../../../config/menu-items.json').items;

let Navigation = React.createClass({
    render: function () {
        return (
            <aside id="left-panel">

                <nav>
                    <SmartMenu rawItems={rawItems} />
                </nav>
                <MinifyMenu />
            </aside>
        )
    }
});

export default Navigation



// WEBPACK FOOTER //
// ./src/pages/layout/Navigation.jsx